import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import css from './TopbarDesktop.css';
import IconChevron from '../IconChevron/IconChevron';
import { FormattedMessage } from 'react-intl';
import NamedLink from '../NamedLink/NamedLink';
import categoryRoutesConfiguration from '../../categoryRoutes';
import config from '../../config';

const { categories } = config;

const Topbar = ({ isLandingPage }) => {
  const routes = categoryRoutesConfiguration();
  const currentCountry = process.env.REACT_APP_COUNTRY_ID || 'pl';

  const topbarRef = useRef(null);
  const [activeCategory, setActiveCategory] = useState(null);

  const handleCategoryClick = (categoryName) => {
    setActiveCategory(activeCategory === categoryName ? null : categoryName);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (topbarRef.current && !topbarRef.current.contains(event.target)) {
        setActiveCategory(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Funkcja pomocnicza: sprawdzamy, czy dana trasa (podkategoria określona przez sub.name)
  // jest dostępna dla bieżącego kraju. Jeśli tak, zwracamy oryginalną nazwę, w przeciwnym razie fallback do "SearchPage".
  const getLinkName = (subName) => {
    const route = routes.find(r => r.name === subName);
    return route && route.countries.includes(currentCountry)
      ? subName
      : 'SearchPage';
  };

  return (
    <div className={classNames(css.categoryWrapper, { [css.lp]: isLandingPage })} ref={topbarRef}>
      <ul className={css.categoryBar}>
        {categories.filter(cat => cat.countries.includes(currentCountry)).map((category,index) => (
          <li
            key={`${category.name}-${index}`}
            className={classNames(css.category, { [css.active]: activeCategory === category.name })}
            onClick={() => handleCategoryClick(category.name)}
          >
            <FormattedMessage id={category.name} /> <IconChevron />
            {activeCategory === category.name && (
              <ul className={css.subcategories}>
                {category.subcategories.filter(sub => sub.countries.includes(currentCountry)).map((sub) => {
                  // Ustalamy nazwę linku – jeśli podana trasa nie jest dostępna dla bieżącego kraju,
                  // getLinkName zwróci "SearchPage"
                  const linkName = getLinkName(sub.name);
                  // Wyszukujemy odpowiadającą konfigurację trasy
                  const matchingRoute = routes.find(r => r.name === sub.name);

                  // Jeśli linkName wskazuje na fallback ("SearchPage") oraz znaleziono konfigurację,
                  // przekazujemy dodatkowy parametr businessCategory (wartość klucza z route)
                  const linkProps =
                    linkName === 'SearchPage' && matchingRoute
                      ? {
                        to: {
                          search: `businessCategory=${matchingRoute.key}&exact=true`,
                        },
                      }
                      : {};

                  return (
                    <li key={sub.name} className={css.subcategory}>
                      <NamedLink name={linkName} {...linkProps} className={css.link}>
                        <FormattedMessage id={sub.translation} />
                      </NamedLink>
                    </li>
                  );
                })}
              </ul>
            )}
          </li>
        ))}
        {
          false && process.env.REACT_APP_COUNTRY_ID === 'pl' && (
            <li
              key="subscription"
              className={classNames(css.category)}
            >
              <NamedLink name="SubscriptionSearchPage" className={classNames(css.link, css.subscription)}>
                <FormattedMessage id="TopbarDesktop.subscription" />
              </NamedLink>
            </li>
          )
        }
      </ul>
    </div>
  );
};

export default Topbar;
